import $ from 'jquery';
import whatInput from 'what-input';

window.$ = $;

import Foundation from 'foundation-sites';

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';

//import './lib/demosite';

require('./lib/slick.min.js');

$(document).foundation();


// Advanced tabs in elementor.
$('.tabs-nav a').on('click', function( event ) {
    var currentTab = $(this).attr('href');
    $('.tabs-nav a').removeClass('active');
    $(this).addClass('active');
    $('.tab-content').hide();
    $(currentTab).show();
    return false;
});

//initial activate tab with 'tab-active'
$('.tabs-nav .tab-active').find('a').trigger('click').addClass('active');


// check for object fit
/*! modernizr 3.5.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-setclasses !*/
 !function(n,e,s){function o(n,e){return typeof n===e}function a(){var n,e,s,a,i,l,r;for(var c in f)if(f.hasOwnProperty(c)){if(n=[],e=f[c],e.name&&(n.push(e.name.toLowerCase()),e.options&&e.options.aliases&&e.options.aliases.length))for(s=0;s<e.options.aliases.length;s++)n.push(e.options.aliases[s].toLowerCase());for(a=o(e.fn,"function")?e.fn():e.fn,i=0;i<n.length;i++)l=n[i],r=l.split("."),1===r.length?Modernizr[r[0]]=a:(!Modernizr[r[0]]||Modernizr[r[0]]instanceof Boolean||(Modernizr[r[0]]=new Boolean(Modernizr[r[0]])),Modernizr[r[0]][r[1]]=a),t.push((a?"":"no-")+r.join("-"))}}function i(n){var e=r.className,s=Modernizr._config.classPrefix||"";if(c&&(e=e.baseVal),Modernizr._config.enableJSClass){var o=new RegExp("(^|\\s)"+s+"no-js(\\s|$)");e=e.replace(o,"$1"+s+"js$2")}Modernizr._config.enableClasses&&(e+=" "+s+n.join(" "+s),c?r.className.baseVal=e:r.className=e)}var t=[],f=[],l={_version:"3.5.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(n,e){var s=this;setTimeout(function(){e(s[n])},0)},addTest:function(n,e,s){f.push({name:n,fn:e,options:s})},addAsyncTest:function(n){f.push({name:null,fn:n})}},Modernizr=function(){};Modernizr.prototype=l,Modernizr=new Modernizr;var r=e.documentElement,c="svg"===r.nodeName.toLowerCase();a(),i(t),delete l.addTest,delete l.addAsyncTest;for(var u=0;u<Modernizr._q.length;u++)Modernizr._q[u]();n.Modernizr=Modernizr}(window,document);

 if ( ! Modernizr.objectfit ) {
    $('.image-object-fit').each(function () {
      var $container = $(this),
          imgUrl = $container.find('img').prop('src');
      if (imgUrl) {
        $container
          .css('backgroundImage', 'url(' + imgUrl + ')')
          .addClass('image-latent');
      }  
    });
  }

//var slider = jQuery('.elementor-widget-image-carousel').slick('getSlick');
//slider.slickSetOption( 'centerMode', true,true ); // last true triggers a refresh of the UI.


// $(".teaserslider").slick({
//   infinite: true,
//   variableWidth: true,
//   focusOnSelect: true,
//   dots: false,
//   arrows: true
//   // prevArrow: ".button-prev",
//   // nextArrow: ".button-next"
// });

$(window).load(function() {
  $('.flex-control-nav').flexslidere({
    selector: "> li",
    minItems: 2,
    maxItems: 4,
    animation: "slide",
    easing: "swing",
    itemWidth: 200,
    itemMargin: 36,
    direction: "horizontal",
    animationLoop: true
  });
});


// $("ul.products").slick({
//   infinite: true,
//   variableWidth: true,
//   focusOnSelect: true,
//   dots: false,
//   arrows: true
//   // prevArrow: ".button-prev",
//   // nextArrow: ".button-next"
// });



